export enum InstructionFeedbackStatuses {
  TODO = 1,
  IN_PROGRESS = 2,
  COMPLETED = 3
}
